import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { Permiso } from "../../shared/types";
import { Cargando } from "../components/Cargando";
import { useAuth } from "./AuthContext";

export function RutaProtegida({
  permisosRequeridos,
}: {
  permisosRequeridos?: Permiso[];
}) {
  const { usuario, permisos, cargandoInicial } = useAuth();
  const location = useLocation();

  if (cargandoInicial) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Cargando texto="Verificando sesión..." />
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  if (
    usuario.debe_cambiar_password &&
    location.pathname !== "/cambiar-password"
  ) {
    return <Navigate to="/cambiar-password" replace />;
  }

  if (
    permisosRequeridos &&
    !permisosRequeridos.some((p) => permisos.has(p))
  ) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  return <Outlet />;
}
